//////////////////////////////////////////////////////////////////////////////////////   IMPORT
///////////////////////////////////////////////////////////   REACT
import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { Container } from 'react-bootstrap';
///////////////////////////////////////////////////////////   LIBS
import axios from 'axios';
///////////////////////////////////////////////////////////   CONFIG
import { _SETTINGS } from './config/settings';
import generalConfig from './config/general-config/config';
import userConfig from './config/user-config/config';
import videojsSetup from './config/videojs-config/config';
import audioSetup from './config/audio-config/config.js';
///////////////////////////////////////////////////////////   PAGES
import VideojsPlayerPage from './pages/videojs-player/videojs-player-page.component';
import AudioPlayerPage from './pages/audio-player/audio-player-page.component';
///////////////////////////////////////////////////////////   COMPS
import Header from './components/generals/header/header.component';
import HomeMenu from './components/generals/home-menu/home-menu.component';
///////////////////////////////////////////////////////////   SCSS
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.scss';
///////////////////////////////////////////////////////////   INTERFACE
declare global {
  interface Window {
    initMultimediaPlayer?: any;
  }
}
//////////////////////////////////////////////////////////////////////////////////////    CLASS SETUP
class App extends React.Component<any, { [key: string]: any }> {
  constructor(props: any) {
    super(props);
    this.state = {
      _mergedConf: null
    };
  }
  ///////////////////////////////////////////////////////////   LIFECYCLE METHODS
  componentDidMount() {
    this.initMultimediaPlayer();
  }
  ///////////////////////////////////////////////////////////   CLASS METHODS
  /**
   * Init Multimedia Player
   * Player will init based on admin configs or by global variable (window.initMultimediaPlayer -> json)
   */
  private initMultimediaPlayer = async (): Promise<any[] | any> => {
    try {
      if (generalConfig.generalConfig.adminConfigsForDeveloping === false) {
        axios
          .get(window.initMultimediaPlayer)
          .then((res) => {
            this.setState({ _mergedConf: res.data.result });
          })
          .catch((err) => {
            console.log(_SETTINGS.err.init);
          });
      } else {
        this.setState({ _mergedConf: { ...generalConfig, ...userConfig, ...videojsSetup, ...audioSetup } }, () => {
          // console.log(this.state._mergedConf);
        });
      }
    } catch (err) {
      console.log(_SETTINGS.err.init, err);
    }
  };
  private returnHome = () => {
    const { _mergedConf } = this.state,
      genConf = _mergedConf.generalConfig.showPlayerTypes;
    let returnApp = null;
    if (genConf.length === 1) {
      switch (genConf[0]) {
        case 'videojs-player':
          returnApp = <VideojsPlayerPage userConfig={_mergedConf?.userConfig} videoJsPlayer={_mergedConf?.videoJsPlayer} />;
          break;
        case 'audio-player':
          returnApp = <AudioPlayerPage audioPlayer={_mergedConf?.audioPlayer} />;
          break;
        default:
          returnApp = <div>'Error in config'</div>;
          break;
      }
    }
    return returnApp;
  };
  ///////////////////////////////////////////////////////////   RENDER
  render() {
    const { _mergedConf } = this.state;
    return (
      <Container fluid={true} className={'px-0 px-lg-0'}>
        {_mergedConf && _mergedConf.videoJsPlayer?.playerType !== _SETTINGS.playerType.embed ? <Header {..._mergedConf} /> : null}
        <Routes>
          <Route path='/videojs-player' element={<VideojsPlayerPage userConfig={_mergedConf?.userConfig} videoJsPlayer={_mergedConf?.videoJsPlayer} />} />
          <Route path='/audio-player' element={<AudioPlayerPage audioPlayer={_mergedConf?.audioPlayer} />} />
          <Route path='/' element={_mergedConf ? _mergedConf.generalConfig.showPlayerTypes.length === 1 ? <this.returnHome /> : <HomeMenu /> : <></>} />
        </Routes>
      </Container>
    );
  }
}
export default App;
